import {Component, ChangeDetectionStrategy, input} from '@angular/core';

@Component({
    selector: 'app-card-header',
    templateUrl: './card-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    // block host: an inline host around the block div adds empty line boxes (gaps) once it gets padding
    host: {class: 'block'}
})
export class CardHeaderComponent {
  readonly active = input<boolean>(false);
  readonly bgColor = input<string>();
}
